import React, { useState, useRef, useEffect } from "react";
import { signOut, onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebaseModel";
import { useNavigate } from "react-router-dom";
import {
  HiInformationCircle,
  HiMiniSpeakerWave,
  HiSpeakerXMark,
} from "react-icons/hi2";
import { Link } from "react-router-dom";
import { Disclosure, Menu } from "@headlessui/react";
import { useLocation } from "react-router-dom";

const NavBar = (props) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
    });

    return () => unsubscribe();
  }, []);

  const handleLogoutCB = () => {
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        navigate("/");
      })
      .catch((error) => {
        // An error happened.
        console.error("Error signing out:", error);
      });
  };

  const handleHomeLogoCB = () => {
    props.model.resetGame();
    navigate("/");
  };

  const [isPlaying, setIsPlaying] = useState(false);
  const audio = useRef(new Audio("/assets/sounds/dark-matter.mp3"));

  function toggleBackgroundMusicACB() {
    if (isPlaying) {
      audio.current.pause();
      audio.current.currentTime = 0;
    } else {
      audio.current.loop = true;
      audio.current.play();
    }
    setIsPlaying(!isPlaying);
  }

  function toInfoPageACB() {
    navigate("/info");
  }

  return (
    <>
      <Disclosure as="nav" className="bg-gray-800 mb-10">
        <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
          <div className="relative flex h-16 items-center justify-between">
            <div className="flex flex-1 items-center sm:items-stretch sm:justify-start">
              <div className="flex flex-shrink-0 items-center">
                <button onClick={handleHomeLogoCB}>
                  <h1>
                    <b>SpaceGuesser</b>
                  </h1>
                </button>
              </div>
            </div>
            <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
              <button
                type="button"
                onClick={toInfoPageACB}
                className="relative rounded-full bg-gray-800 p-1 text-gray-400 opacity-70 hover:opacity-100 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
              >
                <HiInformationCircle className="h-6 w-6" aria-hidden="true" />
              </button>
              <button
                type="button"
                onClick={toggleBackgroundMusicACB}
                className="relative rounded-full bg-gray-800 p-1 text-gray-400 opacity-70 hover:opacity-100 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
              >
                {isPlaying ? (
                  <HiMiniSpeakerWave className="h-6 w-6" aria-hidden="true" />
                ) : (
                  <HiSpeakerXMark className="h-6 w-6" aria-hidden="true" />
                )}
              </button>

              {/* Profile dropdown */}
              <Menu as="div" className="relative ml-3">
                {user ? (
                  <>
                    <div>
                      <Menu.Button className="relative flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                        <span className="absolute -inset-1.5" />
                        <span className="sr-only">Open user menu</span>
                        <img
                          className="h-8 w-8 rounded-full"
                          src="https://images.rawpixel.com/image_png_800/cHJpdmF0ZS9zdGF0aWMvaW1hZ2VzL3dlYnNpdGUvMjAyMy0wNS9wZG1pc2MxMy13azE2MDE0NTU4YS1pbWFnZV8xLnBuZw.png"
                          alt="Profile"
                        />
                      </Menu.Button>
                    </div>

                    <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-medium bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <Menu.Item
                        className={`hover:text-blue ${
                          location.pathname === "/account" ? "text-blue" : ""
                        }`}
                      >
                        <Link
                          to="/account"
                          className={"text-black block px-4 py-2 text-sm"}
                        >
                          Your Profile
                        </Link>
                      </Menu.Item>

                      <Menu.Item
                        className={`hover:text-blue ${
                          location.pathname === "/personalScoreboard"
                            ? "text-blue"
                            : ""
                        }`}
                      >
                        <Link
                          to="/personalScoreboard"
                          className={"text-black block px-4 py-2 text-sm"}
                        >
                          Personal Scoreboard
                        </Link>
                      </Menu.Item>

                      <Menu.Item
                        className={`hover:text-blue ${
                          location.pathname === "/generalScoreboard"
                            ? "text-blue"
                            : ""
                        }`}
                      >
                        <Link
                          to="/generalScoreboard"
                          className={"text-black block px-4 py-2 text-sm"}
                        >
                          General Scoreboard
                        </Link>
                      </Menu.Item>

                      <Menu.Item className="hover:text-blue">
                        <Link
                          to="/"
                          onClick={handleLogoutCB}
                          className={"text-black block px-4 py-2 text-sm"}
                        >
                          Sign out
                        </Link>
                      </Menu.Item>
                    </Menu.Items>
                  </>
                ) : (
                  <div></div>
                )}
              </Menu>
            </div>
          </div>
        </div>
      </Disclosure>
    </>
  );
};

export default NavBar;
